import React from 'react';
import './UIDeleteAccountView.css';
import UIToast from "../_commons/Toast/UIToast";

class UIDeleteAccountView extends React.Component {

    constructor(props) {
        super(props);
        this.toast = React.createRef();

        this.state = {
        };
    }

    onUserAction(action, data){
        console.log("onUserAction: ", action, data);


    }

    render() {
        console.log('render', this.props);

        const viewState           = this.state.viewState;

        return (
            <div className={"UIDeleteAccountView"}>

                <div>

                </div>

                <UIToast ref={this.toast} />

            </div>
        );
    }
}

export default UIDeleteAccountView;
